import { Injectable } from "@angular/core";
import { Adapter } from "@core/adapter";
import { ManualSearchResult } from "../models/manual/manual-search-result";

@Injectable({providedIn: 'root'})
export class ManualSearchAdapter implements Adapter<ManualSearchResult> {
  constructor(){}
  adapt(item: any): ManualSearchResult {
    return {
      articleId: item.id,
      articleName: item.article.title,
      slug:item.article.slug,
      preview:item.preview,
      foundIn:item.foundIn,
      blockIndex: item.block?item.block.index : 0
    };
  }
}
